<template>
  <div class="mobile-nav">
    <div v-if="!opened" class="main-menu">
      <div class="item-block">
        <menu-item
          text="Solutions and insights"
          caption="Use our corporate insights and engagement tools to discover, analyse and connect with Africa's private sector"
          @click="showSection('solutions')"
        />
        <arrow-right @click="showSection('solutions')" />
      </div>
      <div class="item-block">
        <menu-item
          text="Opportunities for African Businesses"
          caption="Work with our partners to access financing and better integrate your African business into global markets"
          @click="showSection('opportunities')"
        />
        <arrow-right @click="showSection('opportunities')" />
      </div>
      <div class="item-block">
        <menu-item
          text="Engage with African Businesses"
          caption="Identify leading companies via initiatives run by investment firms, multinationals and development partners"
          @click="showSection('invest')"
        />
        <arrow-right @click="showSection('invest')" />
      </div>
      <div class="item-block">
        <menu-item
          text="About us"
          caption="Get to know more about our approach, meet the team or contact us"
          @click="showSection('about')"
        />
        <arrow-right @click="showSection('about')" />
      </div>
    </div>

    <div v-if="opened" class="nav-details">
      <div class="details-header">
        <arrow-left @click="showMainMenu" />
        <h4>{{ selectedTitle }}</h4>
      </div>
      <solutions-menu
        v-if="opened === 'solutions'"
        class="opened-menu"
        @hide="hide"
        v-on-clickaway="hide"
      />

      <opportunities-menu
        v-if="opened === 'opportunities'"
        class="opened-menu"
        @hide="hide"
        v-on-clickaway="hide"
      />

      <deals-menu
        v-if="opened === 'invest'"
        class="opened-menu"
        @hide="hide"
        v-on-clickaway="hide"
      />

      <about-menu
        v-if="opened === 'about'"
        class="opened-menu"
        @hide="hide"
        v-on-clickaway="hide"
      />
    </div>
  </div>
</template>

<script>
import ArrowRight from 'assets/images/icons/arrow-right.svg?inline'
import ArrowLeft from 'assets/images/icons/arrow-left.svg?inline'
import SolutionsMenu from 'theme/layout/menu/solutions-menu'
import OpportunitiesMenu from 'theme/layout/menu/opportunities-menu'
import DealsMenu from 'theme/layout/menu/deals-menu'
import AboutMenu from 'theme/layout/menu/about-menu'
import MenuItem from 'theme/layout/menu/menu-item'

export default {
  name: 'mobile-nav',
  components: {
    ArrowRight,
    ArrowLeft,
    SolutionsMenu,
    OpportunitiesMenu,
    DealsMenu,
    AboutMenu,
    MenuItem,
  },
  data() {
    return {
      opened: '',
    }
  },
  computed: {
    selectedTitle() {
      const titles = {
        solutions: 'Solutions and insights',
        opportunities: 'Opportunities for African Businesses',
        invest: 'Engage with African Businesses',
        funding: 'Seek funding',
        about: 'About us',
      }
      return titles[this.opened] || ''
    },
    userId() {
      return this.$store.state.user.currentUser.userId || 'guest'
    },
  },
  methods: {
    showSection(title) {
      this.opened = title
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'show-section-menu-mobile ' + title,
        eventLabel: 'UserID ' + this.userId,
      })
      this.$gtag.event('show-section-menu-mobile ' + title, {
        'event_category': 'Click',
        'event_label': 'UserID ' + this.userId,
      })
    },
    showMainMenu() {
      this.opened = ''
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-nav {
  height: 100%;
  width: 300px;
  position: fixed;
  z-index: 9000;
  top: 0;
  right: 0;
  background-color: #eee;
  overflow-x: hidden;
  padding-top: $padding-xl;
  transition: 0.5s;
}
.item-block {
  display: flex;
  justify-content: space-between;
  margin-bottom: $margin-m;
  padding: 0px $padding-m;
  svg {
    @extend %icon-std;
    margin-top: $margin-xs;
  }
}
.nav-details {
  a {
    display: block;
    color: $font-secondary-color;
    padding: $padding-xs 0px;
    &:hover {
      color: darken($font-secondary-color, 20%);
    }
  }
}
.details-header {
  display: flex;
  align-items: center;
  padding-left: $padding-s;
  margin-bottom: $margin-m;
  h4 {
    margin-left: $margin-xs;
  }
}
.menu-section {
  padding-left: $padding-xl;
  h6 {
    font-size: $header-size-6;
    font-weight: 600;
    margin-left: $margin-l;
  }
  a {
    margin-left: $margin-l;
  }
}
</style>
